import React, { useState, useRef, useEffect } from "react";
import { Wrapper, Status } from "@googlemaps/react-wrapper";
import { toast } from "react-toastify";
import { useParams ,useNavigate,Link} from "react-router-dom";
import { useDispatch ,useSelector} from 'react-redux'


const PolygonEditor = ({projectId,zoneId,zoneCoordinates}) => {
  const mapRef = useRef();
  const polygonRef = useRef();
  const [initialCoordinates,setInitialCoordinates] =useState(zoneCoordinates)
 
  useEffect(() => {
    const map = new window.google.maps.Map(mapRef.current, {
      center: { lat: 56.93, lng: 32.81 },
      zoom: 5,
    });

    const polygon = new window.google.maps.Polygon({
      paths: initialCoordinates,
      strokeColor: "#FF0000",
      strokeOpacity: 0.8,
      strokeWeight: 2,
      fillColor: "#FF0000",
      fillOpacity: 0.35,
      map: map,
      editable: true,
    });

    polygonRef.current = polygon;

    // Add listener for polygon edit events
    const path = polygon.getPath();
    window.google.maps.event.addListener(path, "set_at", handleEdit);
    window.google.maps.event.addListener(path, "insert_at", handleEdit);
        // Set map center and zoom based on polygon bounds
        const bounds = new window.google.maps.LatLngBounds();
        initialCoordinates.forEach((coordinate) => {
          bounds.extend(new window.google.maps.LatLng(coordinate.lat, coordinate.lng));
        });
        map.fitBounds(bounds);
  }, []);

  const handleEdit = () => {
    console.log("Polygon edited");
  };

  const getUpdatedCoordinates = () => {
    return polygonRef.current
      .getPath()
      .getArray()
      .map((latLng) => ({ lat: latLng.lat(), lng: latLng.lng() }));
  };
  const resetPolygon = () => {
    polygonRef.current.setPaths(initialCoordinates);
  };

  return (
    <div>
      <div className="DrivingZone_S1">
        <button onClick={resetPolygon} className="btn">
          Reset Zone
        </button>
        <button
          onClick={() =>
            console.log("Updated Coordinates:", getUpdatedCoordinates())
          }
          className="btn"
        >
          Update Zone
        </button>
      </div>

      <div ref={mapRef} style={{ height: "400px" }}></div>
    </div>
  );
};

const Render = (status,projectId,zoneId,zoneCoordinates) => {
  switch (status) {
    case Status.LOADING:
      return <p>{status} loading....</p>;
    case Status.FAILURE:
      return <p>{status} Error...</p>;
    case Status.SUCCESS:
      return <PolygonEditor projectId={projectId} zoneId={zoneId} zoneCoordinates={zoneCoordinates}   />;
    default:
      return null;
  }
};

const ShowDrivingZone = () => {
  const { projectId, zoneId,zoneName} = useParams();
  const [zoneCoordinates,setZoneCoordinate]=useState([])

  const dispatch = useDispatch()
  const {DrivingZones}=useSelector((store)=>store.drivingZone)
  const {user}=useSelector((store)=>store.auth)
  const navigate = useNavigate()

  useEffect(()=>{
    if(user && projectId && zoneName){
      if(DrivingZones.length!==0){
        const findZoneById = (zoneId) => {
          
          return DrivingZones.find((zone) =>{return zone.drivingZoneId === parseInt(zoneId,10)});
        };
        if(findZoneById(zoneId)!==undefined){
          const coordinates=findZoneById(zoneId).drivingZone.drivingCenters[0].drivingRegions.map((coord)=>{return{lat:coord.lat,lng:coord.lon}})
          // console.log(findZoneById(zoneId).drivingZone.drivingCenters[0].drivingRegions.map((coord)=>{return{lat:coord.lat,lng:coord.lon}}),"coordinatescoordinatescoordinatescoordinates")
          setZoneCoordinate(coordinates)
        }
      }else{
        navigate(-1)
      }
   
    }else{
      navigate('/signin');
    }
  },[])
  return (
    <div className="Project_Container">
        <div style={{textAlign:'center', width:'100%'}}>
        <h5>Zone name:<span>{zoneName}</span></h5>
        </div> 
      <div className="flex_column form form_project">     
      <div>
        {zoneCoordinates.length>0?        <Wrapper
          apiKey={process.env.REACT_APP_GOOGLE_API_KEY}
          render={(status)=>Render(status,projectId,zoneId,zoneCoordinates)}
          libraries={["drawing", "places","geometry"]}
        />:<p>Something went wrong.....</p>}
      </div>
    </div>
    <div className="nav_btn_group">
      <Link className="secondary_btn" to={`/project-details/${projectId}/drivingzones/view-all-drivingzones`}> View all driving Zone </Link>
      <Link className="secondary_btn" to={`/project-details/${projectId}/drivingzones/add-drivingzone`}> Add driving zone +</Link>
    </div>
    </div>

  );
};

export default ShowDrivingZone;



